// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"U0-z","displaySixCardTiles":"V0-z"};